module.exports = __webpack_public_path__ + "img/emotion-design@2x.7a95031.jpg";